import { Link } from "react-router-dom";
import { useI18n } from "../i18n/index.js";
import styles from "./Footer.module.css";

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className={styles.footer}>
      <nav className={styles.links} aria-label="Footer">
        <Link to="/imprint">{t("footer.imprint")}</Link>
        <Link to="/privacy">{t("footer.privacy")}</Link>
        <Link to="/credits">{t("footer.credits")}</Link>
      </nav>
    </footer>
  );
}
